module.exports = __webpack_public_path__ + "media/wood_5.0484a92a.mp3";